import tw from 'tailwind-styled-components'
import {TextArea} from '@components/common/base/textarea'
import {cn} from '@containers/html-utils'

export const TwTitleRow = tw.div`
  min-w-0
  flex
  gap-8
  items-start
`

export const TwTaskGroupTitle = tw.div`
  task-group-title-new
  flex-none
  min-w-0
  space-y-4
`

export const TwTextAreaWrapper = tw.div`
  flex-1
  flex
  min-w-0
`

export const TwTextArea = tw(TextArea)`
  flex-1
`
// line-clamp-* allows displaying of up to * lines of text while adding an ellipsis if there are more

export const TwTaskGroupTitleText = tw.span<{$renameAllowed?: boolean}>`
  min-w-0
  break-words
  flex-1
  text-16
  leading-6
  font-semibold
  text-primary
  line-clamp-3
  ${p => cn(p.$renameAllowed ? 'cursor-pointer' : 'cursor-default')}
`

// break-words required b/c tippy style doesn't govern how large words are handled
export const TwTooltipText = tw.span`
  break-words
  line-clamp-7
`

export const TwCount = tw.span`
  before:content-["("]
  after:content-[")"]
  text-secondary
`
